howspace.components.card = (() => {
    'use strict';

    return {
        setId: (card, id = howspace.generateRandomStr(12)) => {
            card.prop('id', 'card-' + id);

            const header = card.find('> .card-header');
            const contentId = 'card-' + id + '-content';
            header.find('.card-title').attr('aria-controls', contentId);
            card.find('> .card-content').attr('id', contentId);
        },
        setTitle: (card, title) => {
            card.find('> .card-header .card-title .howspace-text').text(title);
        }
    }
})();
